import { getAPIURL, handleResponseError } from "./api";

/**
 * @returns {Promise<Array<{ id: number, name: string, is_active?: boolean, mappings?: unknown[] }>>}
 */
export const getAllFinJobTypes = async () => {
  const response = await fetch(`${getAPIURL()}fin_job_type/all`, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    await handleResponseError(response, "Ошибка при получении видов работ");
  }

  const data = await response.json();
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.list)) return data.list;
  return [];
};

/**
 * POST /fin_job_type/add
 * @param {{
 *   name: string,
 *   is_active?: boolean,
 *   mappings: Array<{
 *     component: string,
 *     fact_stream_name: string,
 *     fact_stream_id: number,
 *     is_active?: boolean,
 *   }>,
 * }} data
 * @returns {Promise<{ id: number, name: string, is_active: boolean }>}
 */
export const addFinJobType = async (data) => {
  const response = await fetch(`${getAPIURL()}fin_job_type/add`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      name: data.name,
      is_active: data.is_active !== false,
      mappings: data.mappings || [],
    }),
  });

  if (!response.ok) {
    await handleResponseError(response, "Ошибка при создании вида работ Finansist");
  }

  return response.json();
};

/** Компонент маппинга fin_job_type → статья Finansist (зарплата / отчёты). */
export const FIN_JOB_TYPE_MAPPING_COMPONENT = "salary";
